// components/GradeModal.js
import React from 'react';
import RouteList from './RouteList.js';
import { formatGrade } from '@utils/gradeUtils.js';

const GradeModal = ({ isOpen, onClose, gradeData, gradeSystem }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 z-50 overflow-y-auto"
      aria-labelledby="modal-title" 
      role="dialog" 
      aria-modal="true"
    >
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div 
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" 
          onClick={onClose}
        ></div>

        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-7xl sm:w-full mx-4">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 
                className="text-lg leading-6 font-medium text-gray-900" 
                id="modal-title"
              >
                {gradeData && 
                  `${formatGrade(gradeData.grade, gradeSystem)} (${gradeData.routes.length} ascents)`
                }
              </h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                aria-label="Close"
              >
                <span className="text-2xl">&times;</span>
              </button>
            </div>
            <RouteList data={gradeData} gradeSystem={gradeSystem} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GradeModal;